module.exports = __webpack_public_path__ + "static/media/auth2.d6963f8b.svg";